{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/MMSE",
	"name": "MMSE",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "MMSE",
	"purpose": "Évaluation des fonctions cognitives et de la mémoire",
	"description": "Le MMSE est divisé en deux sections, la première requiert des réponses verbales et son score maximum est 21. La seconde partie du test requiert la lecture et l’écriture. Les personnes ayant des troubles visuels peuvent rencontrer certaines difficultés pour cette partie. Le score maximal de la seconde partie est de 9. Le score maximal est de 30. Un score inférieur à 24 indique un trouble cognitif (5% de faux négatifs).",
	"item": [
		{
			"linkId": "mmse-instructions",
			"text": "Posez les questions au patient dans l’ordre indiqué. Prenez le temps et encouragez le patient, sans donner d’indices.",
			"type": "display"
		},
		{
			"linkId": "40100",
			"text": "Orientation - Temps",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-orientation-time-display",
					"text": "Demandez la date. Demandez ensuite précisément les éléments omis.",
					"type": "display"
				},
				{
					"linkId": "40200",
					"text": "En quelle année sommes-nous ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40201",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40202",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40300",
					"text": "En quelle saison sommes-nous ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40301",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40302",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40400",
					"text": "Quelle est la date aujourd’hui ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40401",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40402",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40500",
					"text": "Quel jour de la semaine sommes-nous ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40501",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40502",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40600",
					"text": "En quel mois sommes-nous ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40601",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40602",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "40700",
			"text": "Orientation - Lieu",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-orientation-place-display",
					"text": "Demandez : \"Pouvez-vous me dire le nom de cet endroit ?\" Demandez ensuite précisément les éléments omis.",
					"type": "display"
				},
				{
					"linkId": "40800",
					"text": "Dans quel pays sommes-nous ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40801",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40802",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "40900",
					"text": "Dans quelle ville sommes-nous ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "40901",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "40902",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41000",
					"text": "Dans quel quartier sommes-nous ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41001",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41002",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41100",
					"text": "Quel est le numéro de maison ou l’étage ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41101",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41102",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41200",
					"text": "Quel est le nom de la rue ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41201",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41202",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "41300",
			"text": "Enregistrement",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-registration-display",
					"text": "Nommez trois objets sans lien entre eux, clairement et lentement. Après avoir nommé les trois, demandez au patient de les répéter. Assurez-vous que le patient connaît bien les trois mots pour la question de rappel ultérieure.",
					"type": "display"
				},
				{
					"linkId": "41400",
					"text": "Quel est le premier mot ?",
					"type": "string",
					"required": true
				},
				{
					"linkId": "41500",
					"text": "Quel est le deuxième mot ?",
					"type": "string",
					"required": true
				},
				{
					"linkId": "41600",
					"text": "Quel est le troisième mot ?",
					"type": "string",
					"required": true
				},
				{
					"linkId": "41700",
					"text": "Le premier mot a-t-il été correctement répété ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41701",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41702",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41800",
					"text": "Le deuxième mot a-t-il été correctement répété ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41801",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41802",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "41900",
					"text": "Le troisième mot a-t-il été correctement répété ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "41901",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "41902",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "42000",
			"text": "Attention et calcul",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-attention-display",
					"text": "Demandez au patient de commencer à 100 et de soustraire 7 à chaque fois. Arrêtez après cinq soustractions (93, 86, 79, 72, 65). Si le patient ne peut pas ou ne veut pas faire cette tâche, demandez-lui d’épeler à l’envers un mot de 5 lettres différentes (comme « monde »).",
					"type": "display"
				},
				{
					"linkId": "42100",
					"text": "Quel test voulez-vous utiliser pour l’attention et le calcul ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "42101",
								"display": "Calcul"
							}
						},
						{
							"valueCoding": {
								"code": "42102",
								"display": "Épellation"
							}
						}
					]
				},
				{
					"linkId": "42200",
					"text": "Calcul",
					"type": "group",
					"enableWhen": [
						{
							"question": "42100",
							"operator": "=",
							"answerCoding": {
								"code": "42101"
							}
						}
					],
					"item": [
						{
							"linkId": "42300",
							"text": "Combien de chiffres le patient a-t-il correctement nommés ? (max. 5)",
							"type": "integer",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/minValue",
									"valueInteger": 0
								},
								{
									"url": "http://hl7.org/fhir/StructureDefinition/maxValue",
									"valueInteger": 5
								}
							],
							"required": true
						}
					]
				},
				{
					"linkId": "42800",
					"text": "Test d’épellation",
					"type": "group",
					"enableWhen": [
						{
							"question": "42100",
							"operator": "=",
							"answerCoding": {
								"code": "42102"
							}
						}
					],
					"item": [
						{
							"linkId": "42900",
							"text": "Saisissez le mot choisi.",
							"type": "string",
							"required": true
						},
						{
							"linkId": "43000",
							"text": "Combien de lettres le patient a-t-il correctement nommés ? (max. 5)",
							"type": "integer",
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/minValue",
									"valueInteger": 0
								},
								{
									"url": "http://hl7.org/fhir/StructureDefinition/maxValue",
									"valueInteger": 5
								}
							],
							"required": true
						}
					]
				}
			]
		},
		{
			"linkId": "43500",
			"text": "Rappel",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-recall-display",
					"text": "Demandez au patient s’il/elle peut se rappeler les trois mots demandés précédemment.",
					"type": "display"
				},
				{
					"linkId": "43600",
					"text": "Le premier mot a-t-il été correctement répété ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "43601",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "43602",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "43700",
					"text": "Le deuxième mot a-t-il été correctement répété ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "43701",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "43702",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "43800",
					"text": "Le troisième mot a-t-il été correctement répété ?",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "43801",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "43802",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "43900",
			"text": "Langage",
			"type": "group",
			"item": [
				{
					"linkId": "mmse-language-display",
					"text": "Évalue la dénomination, la répétition, le suivi des consignes, la lecture, l’écriture et la copie.",
					"type": "display"
				},
				{
					"linkId": "44000",
					"text": "Montrez au patient une montre-bracelet et demandez ce que c’est.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44001",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44002",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44100",
					"text": "Montrez au patient un crayon et demandez ce que c’est.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44101",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44102",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44200",
					"text": "Demandez au patient de répéter la phrase suivante (un seul essai) : \"pas de mais, de si, ni de et.\"",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44201",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44202",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44300",
					"text": "Prenez une feuille dans votre main droite.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44301",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44302",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44400",
					"text": "Pliez le papier en deux.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44401",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44402",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44500",
					"text": "Posez le papier par terre.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44501",
								"display": "Correct"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44502",
								"display": "Incorrect"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44600",
					"text": "Écrivez en grandes lettres sur une feuille blanche \"Fermez les yeux\". Demandez au patient de le lire et de faire ce qui est écrit.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44601",
								"display": "Correctement exécuté"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44602",
								"display": "Incorrectement exécuté"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44700",
					"text": "Donnez au patient une feuille blanche et demandez-lui d’écrire une phrase. Ne dictez pas de phrase ; la phrase doit être écrite spontanément.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44701",
								"display": "Écrit une phrase compréhensible avec sujet et verbe"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44702",
								"display": "Incapable d’écrire une phrase"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "44800",
					"text": "Dessinez deux pentagones qui se chevauchent (chaque côté env. 2,5 cm) sur une feuille blanche et demandez au patient de les recopier exactement.",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "44801",
								"display": "Correctement copié (deux pentagones qui se chevauchent)"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "44802",
								"display": "Incorrectement copié"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		}
	]
}
